/**
 * created by tianruojun
 * 编辑器表单布局配置项
 * 每行总宽24
 */
export const informationConfig = {
    default:24,
    summary:24,
    author:12,
    phone:12,
    contact:12,
    photography:12,
    camera:12,
    editor:12,
    deptName:12,
    sourceDeptName:12,
    url: '/cm-sites-pms/story/getExtendsField',
    showFTitle: false,

};

export const formItemSizeConfig = {
    fontSize:14,
    inputHeight:32,
    formItemHeight:{
        default:40,
        textarea:100,
        label:45,
    },
    inputSize:'default',
};
